import React, { useEffect, useMemo, useState } from "react";
import { MainContainer } from "../MainContainer";
import Input from "../../components/UI/Input";
import HtmlMailingContent from "./HtmlMailingContent";
import ReactDOMServer from "react-dom/server";
import { useDispatch, useSelector } from "react-redux";
import {
    getFeaturedProductItemById,
    getFeaturedProductItems,
    getMainImage,
    updateProductsViewsLength
} from "../../actions";
import RenderSelectModel from "../../components/RenderSelectModel";
import { getContacts } from "../../actions/components/contact";
import {
    createAndSendMailing,
    clearMailingStatus,
    getMailing
} from "../../actions/mailing.action";

const senderOptions = [
    { value: "noreply", name: "noreply@alotb.ru — системная" },
    { value: "support", name: "support@alotb.ru — поддержка" },
    { value: "security", name: "security@alotb.ru — безопасность" },
    { value: "billing", name: "billing@alotb.ru — платежи" },
    { value: "updates", name: "updates@alotb.ru — обновления" },
];

const normalizeEmailText = (value = "") => {
    return String(value)
        .split(/[\n,; ]+/)
        .map((item) => item.trim())
        .filter(Boolean);
};

const MailingPage = () => {
    const dispatch = useDispatch();

    const {
        featuredProductItems,
        featuredProductItemObj,
        loading
    } = useSelector((state) => state.featuredProductItem);

    const { mainImage } = useSelector((state) => state.mainImage);
    const { contact } = useSelector((state) => state.contact);
    const mailingState = useSelector((state) => state.mailing || {});

    const [formProductListLink, setFormProductListLink] = useState({
        featuredProductItemId: ""
    });

    const [emailsText, setEmailsText] = useState("mafkirovsk51@yandex.ru");

    const [formMaterial, setFormMaterial] = useState({
        senderKey: "noreply",
        name: "ALOTB",
        phone: "",
        subject: "Проверка рассылки ALOTB",
        message: "Здравствуйте. Это тестовая рассылка ALOTB.",
        html: "",
        replyTo: "support@alotb.ru",
        itemsEmails: ["mafkirovsk51@yandex.ru"],
    });

    const products = featuredProductItemObj?.products || [];

    const htmlPreview = useMemo(() => {
        return ReactDOMServer.renderToString(
            <HtmlMailingContent
                mainImage={mainImage}
                products={products}
                loading={loading}
                contact={contact}
            />
        );
    }, [mainImage, products, loading, contact]);

    useEffect(() => {
        dispatch(getMainImage());
        dispatch(getFeaturedProductItems());
        dispatch(getContacts());
        dispatch(getMailing());

        return () => {
            dispatch(clearMailingStatus());
        };
    }, [dispatch]);

    useEffect(() => {
        if (formProductListLink.featuredProductItemId) {
            dispatch(getFeaturedProductItemById(formProductListLink.featuredProductItemId));
        }
    }, [dispatch, formProductListLink.featuredProductItemId]);

    useEffect(() => {
        setFormMaterial((prevState) => ({
            ...prevState,
            html: htmlPreview,
            itemsEmails: normalizeEmailText(emailsText),
        }));
    }, [htmlPreview, emailsText]);

    const submitMaterial = async () => {
        const payload = {
            ...formMaterial,
            html: htmlPreview,
            itemsEmails: normalizeEmailText(emailsText),
        };

        await dispatch(createAndSendMailing(payload));
    };

    const handleChange = (key, value) => {
        setFormProductListLink({
            ...formProductListLink,
            [key]: value
        });
    };

    const handleMaterialChange = (key, value) => {
        setFormMaterial({
            ...formMaterial,
            [key]: value
        });
    };

    return (
        <MainContainer
            backButtonProduct
            type
            backHref
            title="Рассылка по почтам"
        >
            {mailingState.showAlert && (
                <div
                    style={{
                        padding: "12px 15px",
                        marginBottom: "15px",
                        borderRadius: "6px",
                        background: mailingState.variantAlert === "success" ? "#d1fae5" : "#fee2e2",
                        color: mailingState.variantAlert === "success" ? "#065f46" : "#991b1b",
                        fontWeight: 700
                    }}
                >
                    {mailingState.message || mailingState.error}
                </div>
            )}

            <RenderSelectModel
                value={formProductListLink.featuredProductItemId}
                titleOption="Ничего не привязано"
                title="Выбрать список товаров для письма"
                itemsModel={featuredProductItems || []}
                valueKey="featuredProductItemId"
                handleChange={handleChange}
            />

            <Input
                type="select"
                label="Отправитель"
                value={formMaterial.senderKey}
                placeholder="Выберите отправителя"
                options={senderOptions}
                onChange={(e) => handleMaterialChange("senderKey", e.target.value)}
            />

            <Input
                label="Название отправителя / рассылки"
                value={formMaterial.name}
                placeholder="Введите название"
                name="name"
                onChange={(e) => handleMaterialChange("name", e.target.value)}
            />

            <Input
                label="Reply-To"
                value={formMaterial.replyTo}
                placeholder="support@alotb.ru"
                name="replyTo"
                onChange={(e) => handleMaterialChange("replyTo", e.target.value)}
            />

            <Input
                label="Телефон"
                value={formMaterial.phone}
                placeholder="Введите телефон"
                name="phone"
                onChange={(e) => handleMaterialChange("phone", e.target.value)}
            />

            <Input
                label="Тема письма"
                value={formMaterial.subject}
                placeholder="Введите тему письма"
                name="subject"
                onChange={(e) => handleMaterialChange("subject", e.target.value)}
            />

            <Input
                label="Сообщение"
                value={formMaterial.message}
                placeholder="Введите сообщение"
                name="message"
                onChange={(e) => handleMaterialChange("message", e.target.value)}
            />

            <div style={{ marginBottom: "15px" }}>
                <label style={{ display: "block", marginBottom: "7px", fontWeight: 700 }}>
                    Email получателей
                </label>

                <textarea
                    className="form-control"
                    value={emailsText}
                    placeholder="email1@mail.ru, email2@mail.ru"
                    rows={5}
                    onChange={(e) => setEmailsText(e.target.value)}
                />

                <small>
                    Можно вводить через запятую, пробел, точку с запятой или с новой строки.
                </small>
            </div>

            <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", marginBottom: "20px" }}>
                <button
                    className="file__btn file__download"
                    onClick={submitMaterial}
                    disabled={mailingState.sending || mailingState.loading}
                >
                    {mailingState.sending || mailingState.loading ? "Отправка..." : "Сохранить и отправить"}
                </button>

                <button
                    className="file__btn file__download"
                    onClick={() => dispatch(updateProductsViewsLength())}
                >
                    Обновить все просмотры
                </button>
            </div>

            {mailingState.sentEmails?.length > 0 && (
                <div style={{ marginBottom: "20px" }}>
                    <b>Отправлено через: {mailingState.senderKey}</b>
                    <div>Получателей: {mailingState.sentEmails.length}</div>
                    <ul>
                        {mailingState.sentEmails.map((email) => (
                            <li key={email}>{email}</li>
                        ))}
                    </ul>
                </div>
            )}

            <HtmlMailingContent
                mainImage={mainImage}
                contact={contact}
                products={products}
                loading={loading}
            />
        </MainContainer>
    );
};

export default MailingPage;